import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import AddTab from "./components/add-tab";
import TabSelector from "./components/tab-selector";

const Tabs = ({
    addTab,
    children,
    label,
    readOnly,
    removeTab,
    reportSelectedTab,
    selectedTab,
    tabs,
    tabOptions,
    TabDropdown,
    tabClassOverride = "",
    tabListClasses = "",
    tabContentClasses = "",
}) => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        if (selectedTab === null || selectedTab === undefined) {
            return;
        }

        const tabLocaleCodes = tabs.map((t) => t.value);
        const newIndex = Number.isInteger(selectedTab) ? selectedTab : tabLocaleCodes.indexOf(selectedTab);

        if (newIndex !== selectedIndex) {
            setSelectedIndex(newIndex);
        }
    }, [selectedTab, tabs]);

    const changeTab = (i, d) => {
        if (reportSelectedTab) {
            reportSelectedTab(i, d);
        } else {
            setSelectedIndex(i);
        }
    };

    const add = (i, d) => {
        addTab(i, d);
    };

    const remove = async (index) => {
        const tabToRemove = tabs[index];
        removeTab(index, tabToRemove);
    };

    const existingTabs = [];
    const tabsHtml = tabs.map((tab, index) => {
        existingTabs.push(tab.value); // Add to existing tab list
        const tabName = tab.text || `Panel ${index + 1}`;
        const tabClass = index === Number(selectedIndex) ? `tab -active ${tabClassOverride}` : `tab ${tabClassOverride}`;

        return (
            <button
                key={`tab_${index}`}
                data-index={index}
                className={tabClass}
                onClick={() => {
                    changeTab(index, tab);
                }}
            >
                {tabName}
            </button>
        );
    });

    const tabContent =
        children && children.length > 0
            ? children.map((c, i) => {
                  return (
                      <div
                          key={`tabContent_${i}`}
                          className={classnames("tab-item", { "-active": selectedIndex === i })}
                      >
                          {!readOnly && (
                              <button
                                  className="button -text remove-panel"
                                  onClick={() => {
                                      remove(i);
                                  }}
                              >
                                  <FontAwesomeIcon icon={faTimesCircle} />
                              </button>
                          )}
                          {c}
                      </div>
                  );
              })
            : children
              ? children
              : null;

    return (
        <div className="tab-container">
            <div className={`tab-list ${tabListClasses}`}>
                {tabsHtml}
                {!readOnly && !TabDropdown && (
                    <AddTab
                        addTab={add}
                        label={label}
                    />
                )}
                {!readOnly && TabDropdown && (
                    <TabDropdown
                        addTab={add}
                        existingTabs={existingTabs}
                        options={tabOptions}
                    />
                )}
            </div>
            <div className={`tab-content ${tabContentClasses}`}>{tabContent}</div>
        </div>
    );
};

Tabs.defaultProps = {
    label: "Panel",
    selectedIndex: 0,
    tabs: [],
    addTab: () => {},
    removeTab: () => {},
    tabOptions: [],
    TabDropdown: TabSelector,
};

export default Tabs;
